import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { AdminMenusService } from './admin-menus.service';
import { CommonfunctionService } from '../../services/commonfunction.service';
import { ShareService } from '../services/share.service'
import { ApiserviceService } from '../../apiservice.service';
import { Subscription } from 'rxjs';

interface AdminMenus {
  key: string;
  title?: string;
  icon?: string;
  url: string;
  show: boolean;
  subMenus?: AdminMenus[];
  isSubMenu?: boolean;
  isExpanded?: boolean;
}

interface UserAccess {
  GET: boolean,
  POST: boolean,
  PATCH: boolean,
  DELETE: boolean
}

/**
*
* <strong>List of API using</strong>
* <ol>
* <li>umsapi_user_resource_post</li>
* </ol>
*
*/

@Component({
  selector: 'admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['./admin-sidebar.component.css']
})
export class AdminSidebarComponent implements OnInit, OnDestroy {
  @Input() size: any = 'normal';
  private subs = new Subscription();
  adminMenus: AdminMenus[] = [
    {
      key: 'configuration',
      title: 'Master Configuration',
      icon: 'master_configuration',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'property_settings',
          title: 'Property Type',
          icon: 'property_type',
          url: '/admin/property',
          show: false,
          isSubMenu: true
        },
        {
          key: 'masters',
          title: 'Masters',
          icon: 'masters',
          url: '/admin/masters',
          show: false,
          isSubMenu: true
        },
        {
          key: 'attributes',
          title: 'Attributes',
          icon: 'attribute_group',
          url: '/admin/attribute',
          show: false,
          isSubMenu: true
        },
        {
          key: 'field_settings',
          title: 'Attribute Settings',
          icon: 'field_settings',
          url: '/admin/field',
          show: false,
          isSubMenu: true
        },
      ],
      isExpanded: false
    },
    {
      key: 'assignment_review', // Fixed typo
      title: 'Assignment & Review',
      icon: 'assignment_review',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'assignments',
          title: 'Assignments',
          icon: 'assignments',
          url: '/admin/assignment',
          show: false,
          isSubMenu: true
        },
        {
          key: 'quality',
          title: 'Quality Analysis',
          icon: 'verified',
          url: '/admin/quality',
          show: false,
          isSubMenu: true
        },
      ],
      isExpanded: false
    },
    {
      key: 'dataUpload',
      title: 'Data Upload',
      icon: 'dataUpload',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'csv-upload',
          title: 'CSV Upload',
          icon: 'attach',
          url: '/admin/csv-upload',
          show: false,
          isSubMenu: true
        },
        {
          key: 'new-csv-upload',
          title: 'New CSV Upload',
          icon: 'new_csv',
          url: '/admin/new-csv-upload',
          show: false,
          isSubMenu: true
        },
        {
          key: 'transaction-upload',
          title: 'Transaction Upload',
          icon: 'transaction_upload',
          url: '/admin/transaction-upload',
          show: false,
          isSubMenu: true
        },
        {
          key: 'brands-upload',
          title: 'Brands Upload',
          icon: 'brands_upload',
          url: '/admin/brands-upload',
          show: false,
          isSubMenu: true
        },
        {
          key: 'adm-data',
          title: 'ADM Data',
          icon: 'cloud_upload',
          url: '/admin/adm-data',
          show: false,
          isSubMenu: true
        },
      ],
      isExpanded: false
    },
    {
      key: 'sync',
      title: 'Sync',
      icon: 'sync',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'sync-property-gis',
          title: 'Sync Property GIS',
          icon: 'propertyGis',
          url: '/admin/sync-property-gis',
          show: false,
          isSubMenu: true
        },
        {
          key: 'historical-sync-data',
          title: 'Historical Sync Data',
          icon: 'propertyGis',
          url: '/admin/historical-sync-data',
          show: true,
          isSubMenu: true
        },
      ],
      isExpanded: false
    },
    {
      key: 'calculations_insights',
      title: 'Calculations & Insights',
      icon: 'calculation_insights',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'visibility-calculation',
          title: 'Calculation',
          icon: 'visibility_calculation',
          url: '/admin/calculation',
          show: false,
          isSubMenu: true
        },
        {
          key: 'sync-property',
          title: 'Snapshot',
          icon: 'synchornize',
          url: '/admin/sync-property',
          show: false,
          isSubMenu: true
        },
      ],
      isExpanded: false
    },
    {
      key: 'logs_monitoring',
      title: 'Logs & Monitoring',
      icon: 'logs_monitoring',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'log-setting',
          title: 'Log Setting',
          icon: 'log_setting',
          url: '/admin/log-setting',
          show: false,
          isSubMenu: true
        },
        {
          key: 'in-progress',
          title: 'In Progress',
          icon: 'in_progress',
          url: '/admin/in-progress',
          show: false,
          isSubMenu: true
        },
      ],
      isExpanded: false
    },
    {
      key: 'application_settings',
      title: 'Application Settings',
      icon: 'application_settings',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'settings',
          title: 'Settings',
          icon: 'settings',
          url: '/admin/settings',
          show: false,
          isSubMenu: true
        }
      ],
      isExpanded: false
    },
    {
      key: 'others',
      title: 'Others',
      icon: 'settings',
      url: '',
      show: false,
      subMenus: [
        {
          key: 'property_manage',
          title: 'Property Management',
          icon: 'property_listing',
          url: '/admin/property',
          show: false,
          isSubMenu: true
        },
        {
          key: 'activity_details',
          title: 'Activity Details',
          icon: 'activity_detail',
          url: '',
          show: false,
          isSubMenu: true
        },
        {
          key: 'attribute_deletion',
          title: 'Attribute Data Deletion',
          icon: 'attribute_deletion',
          url: '/admin/attribute-deletion',
          show: false,
          isSubMenu: true
        },
        // {
        //   key : 'dashboard',
        //   title : "Dashboard",
        //   icon : 'dashboard',
        //   url : '/admin',
        //   show : true,
        //   isSubMenu : true
        // },
        // {
        //   key : 'settings',
        //   title : "Settings",
        //   icon : 'settings',
        //   url : '/admin',
        //   show : true,
        //   isSubMenu : true
        // },
        // {
        //   key: 'configuration',
        //   title: "Configuration",
        //   icon: 'tool',
        //   url: '/admin/configuration',
        //   show: false,
        //   isSubMenu: true
        // },
      ],
      isExpanded: false
    },
  ];

  attributes_access: UserAccess;
  constructor(private readonly menus: AdminMenusService, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
    private readonly fnc: CommonfunctionService, private readonly share: ShareService,
    private readonly api: ApiserviceService) {
    iconRegistry.addSvgIcon(
      'gear',
      sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/gear.svg'))
      .addSvgIcon('activity_detail', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/activity_detail.svg'))
      .addSvgIcon('field_settings', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/field_settings.svg'))
      .addSvgIcon('masters', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/masters.svg'))
      .addSvgIcon('property_listing', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/property_listing.svg'))
      .addSvgIcon('settings', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/settings.svg'))
      .addSvgIcon('property_type', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/property_type.svg'))
      .addSvgIcon('attribute_group', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/attribute_group.svg'))
      .addSvgIcon('cloud_upload', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/cloud_upload.svg'))
      .addSvgIcon('assignments', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/my_listing.svg'))
      .addSvgIcon('synchornize', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/synchornize.svg'))
      .addSvgIcon('snapshot', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/Snapshot_data_normal.svg'))
      .addSvgIcon('propertyGis', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/Sync Property GIS_normal.svg'))
      .addSvgIcon('propertyLog', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/Sync Property Log_normal.svg'))
      .addSvgIcon('gisDataUpload', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/my_listing.svg'))
      .addSvgIcon('in_progress', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/in_progress.svg'))
      .addSvgIcon('attribute_deletion', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icon/attributes-deletion.svg'))
      .addSvgIcon('new_csv', sanitizer.bypassSecurityTrustResourceUrl('assets/images/svgicons/new-csv.svg'))
      .addSvgIcon('transaction_upload', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/price_upload_icon.svg'))
      .addSvgIcon('brands_upload', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/brands.svg'))
      .addSvgIcon('visibility_calculation', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/observer-adm-upload.svg'))
      .addSvgIcon('log_setting', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/log-setting.svg'))
      .addSvgIcon('master_configuration', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/master_configuration.svg'))
      .addSvgIcon('assignment_review', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/assignment_review.svg'))
      .addSvgIcon('dataUpload', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/data_upload.svg'))
      .addSvgIcon('sync', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/sync.svg'))
      .addSvgIcon('calculation_insights', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/calculation_insights.svg'))
      .addSvgIcon('logs_monitoring', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/logs_monitoring.svg'))
      .addSvgIcon('application_settings', sanitizer.bypassSecurityTrustResourceUrl('assets/menu/application_settings.svg'));
    this.getAllowResourcesApi();
  }

  ngOnInit() {
    if (!this.size) {
      this.size = 'normal';
    }
    this.setInitialExpandedState();
  }

  isSmall() {
    return this.size === 'small';
  }

  isNormal() {
    return this.size === 'normal';
  }

  getActive(menu: AdminMenus): boolean {
    if (this.menus.getIsActive(menu.key)) {
      return true;
    }
    if (menu.subMenus && menu.subMenus.length > 0) {
      return menu.subMenus.some(subMenu => this.menus.getIsActive(subMenu.key));
    }
    return false;
  }

  setInitialExpandedState() {
    this.adminMenus.forEach(menu => menu.isExpanded = false);

    // Expand only the one that has active menu or submenu
    const activeMenu = this.adminMenus.find(menu => this.getActive(menu));
    if (activeMenu) {
      activeMenu.isExpanded = true;
    }
  }

  toggleMenu(menu: AdminMenus) {
    if (menu.isExpanded) {
      menu.isExpanded = false;
    } else {
      this.adminMenus.forEach(m => m.isExpanded = false); // collapse all
      menu.isExpanded = true; // expand only selected
    }
  }

  getAllowResourcesApi() {
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    const allowResSub = this.api.getUmsData(body).subscribe((res: any) => {
      this.api.allowResources = res.data;
      this.getAllowResource();
    });
    this.subs.add(allowResSub);
  }

  getAllowResource() {
    this.adminMenus.forEach((menu) => {
      let hasAccess = false;
      if (menu.subMenus) {
        menu.subMenus.forEach((subMenu) => {
          let resource: UserAccess;
          switch (subMenu.key) {
            case 'property_settings':
              resource = this.fnc.checkResourceAccess('propertytypes');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'masters':
              resource = this.fnc.checkResourceAccess('masters');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'attributes':
              resource = this.fnc.checkResourceAccess('attributes');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'field_settings':
              resource = this.fnc.checkResourceAccess('attributegroups');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'assignments':
              resource = this.fnc.checkResourceAccess('assignments');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'quality':
              resource = this.fnc.checkResourceAccess('qa_qc');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'csv-upload':
              resource = this.fnc.checkResourceAccess('csv_upload');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'new-csv-upload':
              resource = this.fnc.checkResourceAccess('csv_upload');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'transaction-upload':
              resource = this.fnc.checkResourceAccess('transaction_upload');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'brands-upload':
              resource = this.fnc.checkResourceAccess('brands_upload');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'adm-data':
              resource = this.fnc.checkResourceAccess('adm_data');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'sync-property-gis':
              resource = this.fnc.checkResourceAccess('sync_gis');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'historical-sync-data':
              resource = this.fnc.checkResourceAccess('historical-sync-data');
              hasAccess = true; // when i hget the reason why the show is true by default
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'visibility-calculation':
              resource = this.fnc.checkResourceAccess('visibility_calculation');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'sync-property':
              resource = this.fnc.checkResourceAccess('sync_property');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'log-setting':
              resource = this.fnc.checkResourceAccess('log_setting');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'in-progress':
              resource = this.fnc.checkResourceAccess('in_progress');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'settings':
              resource = this.fnc.checkResourceAccess('setting');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'property_manage':
              resource = this.fnc.checkResourceAccess('property_manage');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            case 'activity_details':
              resource = this.fnc.checkResourceAccess('activity_details');
              if (resource.GET) {
                subMenu.show = true;
                hasAccess = true;
              }
              break;
            // case 'attribute_deletion':
            //   resource = this.fnc.checkResourceAccess('attribute_deletion');
            //   if (resource.GET) {
            //     subMenu.show = true;
            //     hasAccess = true;
            //   }
            //   break;
          }
        });
        menu.show = hasAccess; // Show parent menu if any submenu has access
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}